/**
 * Resolve how many rows the user confirmed in preview (WAC apply gate on backend).
 */
export function previewRowsToChange(preview) {
  if (!preview) {
    return null;
  }

  const direct = preview.rows_to_change;
  if (direct != null && direct !== '') {
    const parsed = Number(direct);
    if (!Number.isNaN(parsed) && parsed > 0) {
      return parsed;
    }
  }

  const stats = preview.stats || {};
  for (const key of ['rows_with_changes', 'sales_rows_with_changes', 'purchase_rows_with_changes']) {
    const parsed = Number(stats[key]);
    if (!Number.isNaN(parsed) && parsed > 0) {
      return parsed;
    }
  }

  return direct ?? null;
}

/**
 * Params sent to POST /accounting/apply — includes preview row count for WAC fixes.
 */
export function buildAccountingApplyParams(baseParams = {}, preview = null) {
  return {
    ...baseParams,
    preview_rows_to_change: previewRowsToChange(preview),
  };
}
